import React from "react";
import { ICustomButtonProps } from "./RoleBasedCustomButton.types";
import { Button, Tooltip } from "@mui/material";
import { usePremissions } from "../../PremissionsProvider/PremissionsProvider";
import { CustomButton } from "../../../Components/CustomButton";

export const RoleBasedCustomButton: React.FC<ICustomButtonProps> = (props) => {
  let { editAccess, moduleId } = props;
  const { getPremissionsByModuleId } = usePremissions();
  const premissions = getPremissionsByModuleId(moduleId);
  editAccess = editAccess || premissions.edit_access;

  if (editAccess) {
    return <CustomButton {...props} />;
  }
  return (
    <Tooltip title="You don't have write access!">
      <CustomButton
        type="button"
        variant="outlined"
        color="error"
        sx={{ opacity: 0.5, cursor: "not-allowed" }}
      >
        {props.children}
      </CustomButton>
    </Tooltip>
  );
};
